import { render, staticRenderFns } from "./CookiesConsentLayout.vue?vue&type=template&id=71a8777b&"
import script from "./CookiesConsentLayout.vue?vue&type=script&lang=js&"
export * from "./CookiesConsentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports